
import Index from '../pages/Index'
import UrlMaker from '../pages/UrlMaker'
import UrlList from '../pages/UrlList'
import IDE from '../pages/ide/Ide'
import Error from '../pages/Error'
// import Login from '../pages/login/Index'

const baseList = [
  { path: '/', redirect: '/ide-preview', name: 'home', component: Index, meta: { auth: false } },
  { path: '/url-maker', name: 'url-maker', component: UrlMaker, meta: { auth: false } },
  { path: '/url-list', name: 'url-list', component: UrlList, meta: { auth: false } },
  { path: '/ide-preview', name: 'ide-preview', component: IDE, meta: { auth: false } },
  { path: '/ide-run', name: 'ide-run', component: IDE, meta: { auth: false } },
  { path: '/ide-edit', name: 'ide-edit', component: IDE, meta: { auth: false } },
  { path: '/error', name: 'error', component: Error, meta: { auth: false } },
  // { path: '/ii', name: 'ii', component: Login, meta: { auth: false } },
]
export default baseList
